import { NavLink, Outlet } from 'react-router-dom';
import AppHeader from '../../components/layout/AppHeader.jsx';

const NAV = [
  { to: '/vms/workers',       label: 'Workers',       testid: 'vms-nav-workers'       },
  { to: '/vms/sow',           label: 'SOW',            testid: 'vms-nav-sow'           },
  { to: '/vms/timecards',     label: 'Timecards',      testid: 'vms-nav-timecards'     },
  { to: '/vms/qualifications', label: 'Qualifications', testid: 'vms-nav-qualifications' },
];

export default function VmsShell() {
  return (
    <div className="hr-shell" data-testid="vms-shell">
      <AppHeader />
      <div className="hr-body">
        <aside className="hr-side">
          <div className="hr-side-title">Vendor Management System</div>
          <ul>
            {NAV.map((n) => (
              <li key={n.to}>
                <NavLink to={n.to} data-testid={n.testid} className={({ isActive }) => (isActive ? 'active' : '')}>
                  {n.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </aside>
        <main className="hr-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
